// Thin presentational wrapper around TonConnect's own connect
// button so it sits inside our surface/border/radius language
// instead of floating as a bare library widget. All of the actual
// connect/disconnect/wallet-selection logic lives inside
// @tonconnect/ui-react — this component only supplies the frame.

import { TonConnectButton } from '@tonconnect/ui-react';
import styles from './WalletCard.module.scss';

export function WalletCard() {
  return (
    <div className={styles.card}>
      <div className={styles.title}>Wallet</div>
      <p className={styles.subtitle}>Connect a TON wallet to pay for Stars and Premium directly on-chain.</p>
      <div className={styles.buttonRow}>
        <TonConnectButton />
      </div>
    </div>
  );
}
